import { gql } from "urql";

export const QueryQualifications = gql`
  query Qualifications(
    $languageId: String!
    $merchantId: String!
    $tokenUser: String
    $targetId: String
  ) {
    data: qualifications(
      param: {
        tokenUser: $tokenUser
        languageId: $languageId
        merchantId: $merchantId
        targetId: $targetId
      }
    ) {
      items {
        id
        expertise
        name
        institute
        yearCompleted
      }
    }
  }
`;
export const QueryQualification = gql`
  query Qualification($languageId: String!, $merchantId: String!, $id: String) {
    qualification(param: { languageId: $languageId, merchantId: $merchantId, id: $id }) {
      id
      expertise
      name
      institute
      yearCompleted
    }
  }
`;
